import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";

const CustomizableProducts = () => {

    const [description, setDescription] = useState({});
    const [juteBag, setJuteBag] = useState([]);
    const [cottonBag, setCottonBag] = useState([]);
    const [nonWoven, setNonWoven] = useState([]);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phonenumber: "",
        description: ""
    });
    const [responseMsg, setResponseMsg] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log(formData);
        try {
            const res = await fetch("https://api.welbeing.in/product-enquery/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    phonenumber: formData.phonenumber,
                    description: formData.description
                })
            });

            const data = await res.json();
            if (data.status === "success") {
                setResponseMsg("Your message has been sent successfully!");
                setFormData({ name: "", email: "", phonenumber: "", description: "" });
                setTimeout(() => setResponseMsg(""), 5000);
            } else {
                setResponseMsg("There was a problem submitting the form. Please try again.");
                setTimeout(() => setResponseMsg(""), 5000);
            }
        } catch (error) {
            setResponseMsg("Server error. Please try again later.");
            setTimeout(() => setResponseMsg(""), 5000);
        }
    };

    useEffect(() => {
        axios.get("https://api.welbeing.in/customize/")
            .then(res => {
                if (res.data.status === "success") {
                    setDescription(res.data.data.description);
                    setJuteBag(res.data.data.jutebag);
                    setCottonBag(res.data.data.cottonbag);
                    setNonWoven(res.data.data.nonwoven);
                }
            })
            .catch(err => console.error("API Error:", err));
    }, []);

    return (
        <>
            <Header />
            <section>
                <div className="container-lg">
                    <div className="title-box7 side-by-side" style={{ marginTop: '150px' }}>
                        <div>
                            <h2 className="heading"><span>Customizable Products</span></h2>
                            <h5 className="heading-2 mt-2">Elevate your style with bags tailored to your needs! We offer customization for Jute Bags, Cotton Bags, and Non-Woven Bags. Whether you're looking for eco-friendly options, durable designs, or stylish everyday carriers, we've got you covered. Personalize your bags to reflect your unique taste and requirements.<br /><br />Order your custom bag today and carry your essentials in style!</h5>
                        </div>

                        <ul className="nav nav-tabs nav-tabs5 round-tab row-tab" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="casual-tab" data-bs-toggle="tab" data-bs-target="#casual" type="button" role="tab" aria-controls="casual" aria-selected="true">Jute Bags</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="athletic-tab" data-bs-toggle="tab" data-bs-target="#athletic" type="button" role="tab" aria-controls="athletic" aria-selected="false">Cotton Bags</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="sport-tab" data-bs-toggle="tab" data-bs-target="#sport" type="button" role="tab" aria-controls="sport" aria-selected="false">Non Woven Bags</button>
                            </li>
                        </ul>
                    </div>

                    <div className="tab-content ratio_40" id="myTabContent">
                        <div className="tab-pane fade show active" id="casual" role="tabpanel" aria-labelledby="casual-tab">
                            <div className="casual-content">
                                <div className="row">
                                    <div className="address-box checked">
                                        <h5 style={{ textAlign: "center" }}><b>Jute Bags</b></h5><br />

                                        {juteBag.map((item, index) => (
                                            <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
                                                <div className="address-detail">
                                                    <div className="image">
                                                        <div className="ImageWrapper zoom-container" style={{ padding: "5px" }}>
                                                            <img src={`https://api.welbeing.in/admin/product_data/${item.image}`} alt="Jute Bag" style={{ width: "100%" }} className="zoom-image" /><br /><br />
                                                            <h6><b>Size:</b> {item.size}</h6><br />
                                                            <h6><b>Price:</b> ₹{item.price}</h6><br />
                                                            <h6><b>Material:</b> {item.material}</h6><br />
                                                            <h6><b>Description:</b> {item.description}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Cotton Bags Tab */}
                        <div className="tab-pane fade" id="athletic" role="tabpanel" aria-labelledby="athletic-tab">
                            <div className="athletic-content">
                                <div className="row">
                                    <div className="address-box checked">
                                        <h5 style={{ textAlign: "center" }}><b>Cotton Bags</b></h5><br />
                                        {cottonBag.map((item, index) => (
                                            <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
                                                <div className="ImageWrapper zoom-container" style={{ padding: "5px" }}>
                                                    <img src={`https://api.welbeing.in/admin/product_data/${item.image}`} alt="Jute Bag" style={{ width: "100%" }} className="zoom-image" /><br /><br />
                                                    <h6><b>Size:</b> {item.size}</h6><br />
                                                    <h6><b>Price:</b> ₹{item.price}</h6><br />
                                                    <h6><b>Material:</b> {item.material}</h6><br />
                                                    <h6><b>Description:</b> {item.description}</h6><br />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Non Woven Bags Tab  */}
                        <div className="tab-pane fade" id="sport" role="tabpanel" aria-labelledby="sport-tab">
                            <div className="sport-content">
                                <h5 className="text-center py-3"><b>Non Woven Bags</b></h5>
                                <div className="row">
                                    {nonWoven.map((bag, index) => (
                                        <div key={index} className="col-md-6 col-lg-4 mb-4">
                                            <div className="address-box checked border-0 p-2">
                                                <div className="ImageWrapper zoom-container" style={{ padding: "5px" }}>
                                                    <img
                                                        src={`https://api.welbeing.in/admin/product_data/${bag.image}`}
                                                        alt={bag.name}
                                                        className="zoom-image"
                                                        style={{ width: "100%", height: "auto" }}
                                                    />
                                                    <h6 style={{ textAlign: "left", padding: "5px" }}>
                                                        <b>Size:</b> {bag.size}
                                                    </h6>
                                                    <h6 style={{ textAlign: "left", padding: "5px" }}>
                                                        <b>Price:</b> ₹{bag.price}
                                                    </h6>
                                                    <h6 style={{ textAlign: "left", padding: "5px" }}>
                                                        <b>Material:</b> {bag.material}
                                                    </h6>
                                                    <h6 style={{ textAlign: "left", padding: "5px" }}>
                                                        <b>Description:</b> {bag.description}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section >

            <section class="contact-section">
                <div class="container-lg">
                    <div class="row gy-4 gy-xl-0 gx-0 gx-xl-4" style={{ alignItems: 'center' }}>
                        <div class="col-xl-12 order-2 order-xl-1">
                            <div class="replay-form round-wrap-content top-space" id="replaySection">

                                <div class="option">
                                    <p class="content-color" style={{ textAlign: 'center' }}>For Customization & Bulk Order Contact. <br /><a href="tel:+919047473959" class="btn-solid btn-sm info-btns mt-3"><i class="fa fa-phone"></i> +91 904747 3959</a></p>
                                </div>
                                <div class="title-box4">
                                    <h4 class="heading">For Orders<span class="bg-theme-blue mt-3"></span></h4>
                                </div>

                                <form className="custom-form form-pill" onSubmit={handleSubmit}>
                                    {responseMsg && (
                                        <div className="col-12">
                                            <p className="alert alert-info">{responseMsg}</p>
                                        </div>
                                    )}
                                    <div class="row g-3 g-sm-4">
                                        <div class="col-sm-4">
                                            <div class="input-box">
                                                <label for="fName">Full Name</label>
                                                <input name="name" id="name" type="text" className="form-control" value={formData.name} onChange={handleChange} required />
                                            </div>
                                        </div>


                                        <div class="col-sm-4">
                                            <div class="input-box">
                                                <label for="email">Email Address</label>
                                                <input name="email" id="email" type="email" className="form-control" value={formData.email} onChange={handleChange} required />
                                            </div>
                                        </div>

                                        <div class="col-sm-4">
                                            <div class="input-box">
                                                <label for="email">Phone Number</label>
                                                <input name="phonenumber" id="phonenumber" type="tel" className="form-control" value={formData.phonenumber} onChange={handleChange} required />
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <div class="input-box">
                                                <label for="comment">Description</label>
                                                <textarea name="description" id="description" className="form-control" rows="5" value={formData.description} onChange={handleChange} required ></textarea>
                                            </div>
                                        </div>

                                        <div class="col-12 text-end">
                                            <button type="submit" class="post-button btn btn-solid btn-sm mb-line" name="productenquery">Submit<i class="arrow"></i></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    )
}

export default CustomizableProducts;